import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { StylableComponent } from '@adsk/alloy-react-theme';

import Modal from './components/Modal';
import { Offering } from './helpers/types';

type SubscriptionsModalViewProps = StylableComponent<HTMLDivElement> & {
  onCloseModal: () => void;
  subscriptions: Offering[];
  error: boolean;
  isLoading: boolean;
  refetch: () => void;
};
const SubscriptionsModalView = React.forwardRef<
  HTMLDivElement,
  SubscriptionsModalViewProps
>(
  (
    {
      className,
      onCloseModal,
      isLoading,
      error,
      style,
      subscriptions,
      refetch,
      color: _color, // this prop is ignored to fix an error with Flex getting wrong color type
      ...props
    },
    ref,
  ) => {
    return (
      <Flex
        flexDirection="row"
        className={className}
        style={style}
        ref={ref}
        data-testid="SubscriptionsModalView"
        {...props}
      >
        <Modal
          isLoading={isLoading}
          onClose={onCloseModal}
          error={error}
          subscriptions={subscriptions}
          onClickTryAgain={refetch}
        />
      </Flex>
    );
  },
);

SubscriptionsModalView.displayName = 'SubscriptionsModalView';

export default SubscriptionsModalView;
